require("./src/styles/global.css");
require('./src/i18n/i18n');

exports.onRouteUpdate = () => {
  const event = new Event("gatsby:routeUpdated");
  window.dispatchEvent(event);
};
